import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { close as closeModal } from '../../../modules/modal/actions';
import Button from '../../../components/common/Button';
import { cancelRequest } from '../../withdraw/actions';
import Translation from '../../i18n/Translation';

export const CancelWithdrawal = ({ close, cancelWithdraw }) => {
  const requestCancelWithdrawal = () => {
    close();
    cancelWithdraw();
  };
  return (
    <div className="modal">
      <h2 className="modal__header">
        <Translation section="withdraw" label="cancelModalTitle" />
      </h2>
      <p className="modal__paragraph">
        <Translation section="withdraw" label="cancelModalContent" />
      </p>
      <div className="modal__button-line">
        <Button className="modal__button button--secondary" onClick={close}>
          <Translation section="common" label="no" />
        </Button>
        <Button className="modal__button" onClick={requestCancelWithdrawal}>
          <Translation section="common" label="yes" />
        </Button>
      </div>
    </div>
  );
};

CancelWithdrawal.propTypes = {
  close: PropTypes.func.isRequired,
  cancelWithdraw: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  close: closeModal,
  cancelWithdraw: cancelRequest
};

export default connect(null, mapDispatchToProps)(CancelWithdrawal);
